import { useEffect, useState, useMemo } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  Container,
  Row,
  Button,
  ButtonGroup,
  Col,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Spinner,
  Form,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CustomTable from "components/CustomTable";
import { FaTimes, FaKey, FaFilePdf, FaPrint } from "react-icons/fa";
import copy from 'copy-to-clipboard';
import ReactPaginate from "react-paginate";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { apiURL1 } from '../../config';
import axios from "axios";
import TeacherReport from "./TeacherReport";
import Footer from "components/Footers/Footer";


const TeacherManagement = () => {
  const token = localStorage.getItem("token");

  const navigate = useNavigate();
  const columns = ["id", "Code", "Name", "Email", "Type", "Actions"];
  const [teacherId, setTeacherId] = useState("");
  const [rows, setRows] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [showCredentialsModal, setShowCredentialsModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [generatedCredentials, setGeneratedCredentials] = useState({ email: '', password: '' });

  const [addTeacherFormData, setAddTeacherFormData] = useState({
    name: "",
    email: "",
    password: "",
    salary: "",
    type: "full-time",
    salaryUnit: "",
    classesAndSubjects: [{ subject: "" }],
  });
  const [emailError, setEmailError] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const [teachers, setTeachers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [madrasaInfo, setMadrasaInfo] = useState({});

  useEffect(() => {
    fetchTeachers();
    fetchMadrasaInfo();
  }, [currentPage]);

  const fetchMadrasaInfo = async () => {
    try {
      const response = await axios.get(`${apiURL1}/superadmin/school-settings`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = response.data;
      if (data && data.length > 0) {
        setMadrasaInfo(data[0]);
      }
    } catch (error) {
      // console.error('Error fetching madrasa info:', error);
    }
  };

  const fetchTeachers = async () => {
    try {
      setIsLoading(true);
      const response1 = await axios.get(`${apiURL1}/superadmin/action-logs`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data1 = response1.data;
      console.log('data 1 is ', data1)

      const response = await fetch(`${apiURL1}/superadmin/getAllTeachers`, {
        method: 'GET', // or any other HTTP method as needed
        headers: {
          'Authorization': `Bearer ${token}`, // Add token to headers
          // Any other headers can go here
        },
      });
      const result = await response.json();

      if (result && result.teachers) {
        setTeachers(result.teachers);
        setTotalCount(result.teachers.length);
      } else {
        setTeachers([]);
        setTotalCount(0);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error("Error fetching teachers");
      setTeachers([]);
      setTotalCount(0);
      setIsLoading(false);
    }
  };
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const addToggle = () => {
    setAddModal(!addModal);
    setAddTeacherFormData({
      name: "",
      email: "",
      password: "",
      salary: "",
      type: "full-time",
      salaryUnit: "",
      classesAndSubjects: [{ subject: "" }],
    });
    setEmailError("");
  };

  const editToggle = () => setEditModal(!editModal);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const changePasswordToggle = () => {
    // console.log('changePasswordModal is ', !changePasswordModal)
    setChangePasswordModal(!changePasswordModal);
    setIsPasswordUpdated(false);
    setNewPassword("");
  }
  const credentialsToggle = () => {
    // console.log(' showCredentialsModal is ', showCredentialsModal)
    setShowCredentialsModal(!showCredentialsModal);

  };

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddTeacherFormData({ ...addTeacherFormData, [name]: value });

    // Real-time email validation
    if (name === 'email') {
      if (value && !validateEmail(value)) {
        setEmailError("Please enter a valid email address");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubjectChange = (e, index) => {
    const { value } = e.target;
    const updatedSubjects = [...addTeacherFormData.classesAndSubjects];
    updatedSubjects[index].subject = value;
    setAddTeacherFormData({
      ...addTeacherFormData,
      classesAndSubjects: updatedSubjects,
    });
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();

    // Validate email before submission
    if (!validateEmail(addTeacherFormData.email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    try {
      if (addTeacherFormData) {
        if (addTeacherFormData.type == 'full-time') {
          addTeacherFormData.salaryUnit = 'M';
        }
        else if (addTeacherFormData.type == 'part-time') {
          addTeacherFormData.salaryUnit = 'M';
        }
        else if (addTeacherFormData.type == 'visitor') {
          addTeacherFormData.salaryUnit = 'H';

        }

      }
      const response = await fetch(`${apiURL1}/superadmin/teachers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`, // Add token to headers

        },
        body: JSON.stringify(addTeacherFormData),
      });
      if (response.ok) {
        const result = await response.json();
        toast.success("Staff Created");
        setGeneratedCredentials({ email: addTeacherFormData.email, password: addTeacherFormData.password });
        credentialsToggle();
        addToggle();
        setAddTeacherFormData({
          name: "",
          email: "",
          password: "",
          salary: "",
          salaryUnit: "",
          type: "full-time",
          classesAndSubjects: [{ subject: "" }],
        });
        setEmailError("");
        fetchTeachers()
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Error creating Staff");
      }
    } catch (error) {
      toast.error("Error creating Staff");
    }
  };


  const handleEdit = async (id) => {
    setTeacherId(id);
    try {
      const response = await fetch(`${apiURL1}/superadmin/getTeacherById/${id}`, {
        method: 'GET', // or any other HTTP method as needed
        headers: {
          'Authorization': `Bearer ${token}`, // Add token to headers
          // Any other headers can go here
        },
      });
      const data = await response.json();
      setAddTeacherFormData({
        name: data.teacher.name,
        email: data.teacher.email,
        salary: data.teacher.salary,
        type: data.teacher.type,
        salaryUnit: data.teacher.salaryUnit,
        classesAndSubjects: data.teacher.classesAndSubjects.length
          ? data.teacher.classesAndSubjects
          : [{ subject: "" }],
      });
      editToggle();
    } catch (error) {
      toast.error("Error fetching staff details");
    }
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(`${apiURL1}/superadmin/teachers/${teacherId}`, {
        method: "DELETE",
        headers: {
          'Authorization': `Bearer ${token}`, // Add token to headers

        },
      });
      if (response.ok) {
        toast.success("Staff deleted successfully!");
        setTeachers(teachers.filter((teacher) => teacher._id !== teacherId));
      } else {
        toast.error("Error deleting Staff");
      }
    } catch (error) {
      toast.error("Error deleting Staff");
    }
    deleteToggle();
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      if (addTeacherFormData) {
        if (addTeacherFormData.type == 'full-time') {
          addTeacherFormData.salaryUnit = 'M';
        }
        else if (addTeacherFormData.type == 'part-time') {
          addTeacherFormData.salaryUnit = 'M';
        }
        else if (addTeacherFormData.type == 'visitor') {
          addTeacherFormData.salaryUnit = 'H';

        }
      }
      const response = await fetch(`${apiURL1}/superadmin/teachers/${teacherId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`, // Add token to headers

        },
        body: JSON.stringify(addTeacherFormData),
      });
      if (response.ok) {
        toast.success("Staff updated successfully!");
        fetchTeachers()
        editToggle();
      } else {
        toast.error("Error updating Staff");
      }
    } catch (error) {
      toast.error("Error updating Staff");
    }
  };
  const handleChangePassword = async () => {
    try {
      const response = await fetch(`${apiURL1}/superadmin/teacher/change-password/${teacherId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`, // Add token to headers

        },
        body: JSON.stringify({ newPassword }),
      });
      if (response.ok) {
        toast.success("Staff password updated successfully!");
        setGeneratedCredentials({ email: teachers.find(teacher => teacher._id === teacherId)?.email, password: newPassword });
        setChangePasswordModal(false);
        credentialsToggle()
      } else {
        toast.error("Error updating Staff password");
      }
    } catch (error) {
      toast.error("Error updating Staff password");
    }
  };


  const filteredTeachers = useMemo(() => {
    return teachers.filter(teacher => {
      const nameMatch = filterName ? teacher.name.toLowerCase().includes(filterName.toLowerCase()) : true;
      const emailMatch = filterEmail ? teacher.email.toLowerCase().includes(filterEmail.toLowerCase()) : true;
      return nameMatch && emailMatch;
    });
  }, [teachers, filterName, filterEmail]);


  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


  const openPrintView = (teacher, madrasaInfo) => {
    const printContent = `
    <html>
      <head>
        <title>Staff Report - ${teacher.name}</title>
        <style>
          @page { margin: 20px; }
          body { font-family: Arial; margin: 20px; }
          .header { text-align: center; margin-bottom: 20px; }
          .logo { width: 100px; height: 100px; }
          .school-info { margin-bottom: 15px; }
          table { width: 100%; border-collapse: collapse; margin: 15px 0; }
          th { background-color: #2980b9; color: white; padding: 8px; }
          td { padding: 8px; border: 1px solid #ddd; }
          .section-title { font-size: 16px; margin: 20px 0 10px; }
          .sub-section { margin-left: 15px; margin-top: 10px; }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
               class="logo" alt="School Logo">
          <div class="school-info">
            <h2>${madrasaInfo?.schoolName || 'Ummu Dhardha Ladies Islamic College'}</h2>
            <p>${madrasaInfo?.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.'}</p>
            <p>Tel: ${madrasaInfo?.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${madrasaInfo?.schoolEmail || 'info@ummudhardha.lk'}</p>
          </div>
        </div>

        <h2>Staff Report: ${teacher?.name || 'N/A'}</h2>
        
        <div class="section">
          <h3 class="section-title">Personal Information</h3>
          <p>Staff ID: ${teacher?.teacherID || 'N/A'}</p>
          <p>Name: ${teacher?.name || 'N/A'}</p>
          <p>Email: ${teacher?.email || 'N/A'}</p>
          <p>Type: ${teacher?.type || 'N/A'}</p>
          <p>Salary: ${teacher?.salary || 'N/A'}</p>
          <p>Salary Unit: ${teacher?.salaryUnit || 'N/A'}</p>
          <p>Join Date: ${teacher?.joinDate ? formatDate(teacher.joinDate) : 'N/A'}</p>
          <p>City: ${teacher?.city || 'N/A'}</p>
          <p>Country: ${teacher?.country || 'N/A'}</p>
          <p>State: ${teacher?.state || 'N/A'}</p>
          <p>Years of Experience: ${teacher?.yearOfExperince || 'N/A'}</p>
        </div>

        <div class="footer">
          Generated on: ${new Date().toLocaleDateString()}
        </div>
      </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };


  const reArrageData = () => {
    const tempArr = filteredTeachers.map((teacher) => ({
      id: teacher.teacherID ? teacher.teacherID : '-',
      code: teacher.emp_code ? teacher.emp_code : '-',
      name: teacher.name,
      email: teacher.email,
      type: teacher.type.toUpperCase(),
      actions: (
        <ButtonGroup size="sm">
          <Button
            size="sm"
            color="danger"
            onClick={() => {
              deleteToggle();
              setTeacherId(teacher._id);
            }}
          >
            <i className="fas fa-user-times"></i>
          </Button>
          <Button
            size="sm"
            color="success"
            onClick={() => navigate(`/admin/AddTeacher/${teacher._id}`)}
          >
            <i className="fa-regular fa-eye"></i>
          </Button>
          <Button
            size="sm"
            color="info"
            onClick={() => {
              setTeacherId(teacher._id);
              changePasswordToggle();
            }}
          >
            <FaKey />
          </Button>
          <Button
            size="sm"
            color="secondary"
            onClick={() => openPrintView(teacher, madrasaInfo)}
          >
            <FaPrint />
          </Button>
        </ButtonGroup>
      ),
    }));
    setRows(tempArr);
  };

  useEffect(() => {
    reArrageData();
  }, [filteredTeachers, madrasaInfo]);

  const handleCopyToClipboard = () => {
    copy(`${generatedCredentials.email}\n${generatedCredentials.password}`);
    toast.success("Credentials copied to clipboard!");
    credentialsToggle();
  };

  const generateReport = async () => {
    setIsLoading(true);
    try {
      // Fetch all teachers without pagination
      const response = await fetch(`${apiURL1}/superadmin/getAllTeachers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const allTeachers = result.teachers;

      // Initialize jsPDF
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 10;
      let y = 50;

      // School Logo and Information (Header)
      const img = new Image();
      img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

      doc.addImage(img, 'PNG', 15, 15, 30, 30);

      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(madrasaInfo.schoolName || 'Madrasa Name', 50, 22);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(madrasaInfo.schoolAddress || 'Madrasa Address', 50, 28);
      doc.text(`Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}`, 50, 34);

      // Report Title
      doc.setFontSize(18);
      doc.text('Staff Information Report', pageWidth / 2, 55, { align: 'center' });

      // Define the columns for the table
      const columns = ["Name", "Email", "Type", "Salary"];

      // Prepare the data for the table
      const data = allTeachers.map(teacher => [
        teacher.name,
        teacher.email,
        teacher.type,
        teacher.salary
      ]);

      // Add the table to the PDF
      doc.autoTable({
        startY: 65,
        head: [columns],
        body: data,
        margin: { left: 15, right: 15 },
      });

      // Footer
      const totalPages = doc.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.text(`Generated on: ${new Date().toLocaleDateString()} | ${madrasaInfo.schoolName || 'Madrasa Name'}`,
          pageWidth - 40, doc.internal.pageSize.getHeight() - 10);
      }

      // Save the PDF
      doc.save('teacher_report.pdf');
      toast.success("Report generated successfully!");
    } catch (error) {
      // console.error("Error generating report:", error);
      toast.error("Failed to generate report!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Button
              className="d-block ml-auto mb-2"
              color="secondary"
              size="sm"
              onClick={addToggle}
            >
              Add Staff
            </Button>
            <Card className="shadow">
              <CardHeader className="border-0 px-0 px-md-2 d-flex align-items-center">
                <Col xs="auto">
                  <h3 className="mb-0">Staffs</h3>
                </Col>
                <Col className="d-flex justify-content-end align-items-center">
                  <FormGroup className="mr-2 mb-0">
                    <Input
                      bsSize="sm"
                      type="text"
                      placeholder="Filter by Name"
                      value={filterName}
                      onChange={(e) => setFilterName(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="mr-2 mb-0">
                    <Input
                      bsSize="sm"
                      type="text"
                      placeholder="Filter by Email"
                      value={filterEmail}
                      onChange={(e) => setFilterEmail(e.target.value)}
                    />
                  </FormGroup>
                  <Button color="primary" size="sm" onClick={generateReport} disabled={isLoading}>
                    {isLoading ? <Spinner size="sm" /> : <FaFilePdf />} Generate Report
                  </Button>
                </Col>
              </CardHeader>
              {isLoading ? (
                <Spinner size="lg" className="my-5 mx-auto" />
              ) : (
                teachers.length > 0 ? (
                  <CustomTable columns={columns} rows={rows} />
                ) : (
                  <div className="text-center py-3">No Staff found.</div>
                )
              )}
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    <ReactPaginate
                      previousLabel={
                        <i
                          className="previous fa fa-chevron-left"
                          aria-hidden="true"
                        ></i>
                      }
                      nextLabel={
                        <i
                          className="next fa fa-chevron-right"
                          aria-hidden="true"
                        ></i>
                      }
                      breakLabel={"..."}
                      pageCount={Math.ceil(totalCount / itemsPerPage)}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-end mb-0"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      activeClassName={"active"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>

        {/* Edit Teacher Modal */}
        <Modal isOpen={editModal} toggle={editToggle}>
          <ModalHeader className="pb-0">Edit Staff
            <Button
              className="close"
              onClick={editToggle}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column">
            <Form onSubmit={handleUpdate}>
              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Name</Label>
                  <Input
                    placeholder="Enter staff's name"
                    name="name"
                    required
                    value={addTeacherFormData.name}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.name ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Email</Label>
                  <Input
                    placeholder="Enter email"
                    name="email"
                    required
                    value={addTeacherFormData.email}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.email ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Salary</Label>
                  <Input
                    placeholder="Enter salary"
                    type="number"
                    name="salary"
                    required
                    value={addTeacherFormData.salary}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.salary ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Type</Label>
                  <Input
                    type="select"
                    name="type"
                    value={addTeacherFormData.type}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.type ? '#000' : '', opacity: 1 }}

                  >
                    <option value="full-time">Full-Time</option>
                    <option value="part-time">Part-Time</option>
                    <option value="visitor">Visitor</option>

                  </Input>
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">

              </Row>

              <Button
                color="primary"
                type="submit"
                className="mt-4 w-100 mb-10"
                style={{ marginBottom: "1rem" }}

              >
                Update Staff
              </Button>
            </Form>
          </ModalBody>
        </Modal>

        {/* Add Teacher Modal */}
        <Modal isOpen={addModal} toggle={addToggle}>
          <ModalHeader className="pb-0">Add Staff
            <Button
              className="close"
              onClick={addToggle}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column">
            <Form onSubmit={handleAddSubmit}>
              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Name</Label>
                  <Input
                    placeholder="Enter Staff's name"
                    name="name"
                    required
                    value={addTeacherFormData.name}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.name ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Email</Label>
                  <Input
                    placeholder="Enter email"
                    name="email"
                    type="email"
                    autoComplete="new-email"
                    required
                    value={addTeacherFormData.email}
                    onChange={handleAddInputChange}
                    style={{
                      color: addTeacherFormData.email ? '#000' : '',
                      opacity: 1,
                      borderColor: emailError ? '#dc3545' : ''
                    }}
                  />
                  {emailError && (
                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                      {emailError}
                    </div>
                  )}
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Password</Label>
                  <Input
                    placeholder="Enter password"
                    type="password"
                    name="password"
                    autoComplete="new-password"
                    required
                    value={addTeacherFormData.password}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.password ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Basic Salary</Label>
                  <Input
                    placeholder="Enter basic salary"
                    type="number"
                    name="salary"
                    required
                    value={addTeacherFormData.salary}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.salary ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>Type of Staff</Label>
                  <Input
                    type="select"
                    name="type"
                    value={addTeacherFormData.type}
                    onChange={handleAddInputChange}
                    style={{ color: addTeacherFormData.type ? '#000' : '', opacity: 1 }}

                  >
                    <option value="full-time">Full-Time</option>
                    <option value="part-time">Part-Time</option>
                    <option value="visitor">Visitor</option>
                  </Input>
                </FormGroup>
              </Row>

              <Row className="mt-4 w-100">

              </Row>

              <Button
                color="primary"
                type="submit"
                className="mt-4 w-100 mb-10"
                style={{ marginBottom: "1rem" }}
              >
                Add Staff
              </Button>
            </Form>
          </ModalBody>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal isOpen={deleteModal} toggle={deleteToggle}>
          <ModalHeader className="pb-0">Delete Staff
            <Button
              className="close"
              onClick={deleteToggle}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column justify-content-center align-items-center">
            <p>Are you sure you want to delete this Staff?</p>
            <div className="d-flex justify-content-center" style={{ marginBottom: "1rem" }}
            >
              <Button color="danger" onClick={handleDelete} className="mx-2"
              >
                Yes, Delete
              </Button>
              <Button color="secondary" onClick={deleteToggle} className="mx-2">
                Cancel
              </Button>
            </div>
          </ModalBody>
        </Modal>
        {/* Change Password Modal */}
        <Modal isOpen={changePasswordModal} toggle={changePasswordToggle}>
          <ModalHeader className="pb-0">Change Password
            <Button
              className="close"
              onClick={changePasswordToggle}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column justify-content-center align-items-center">
            <Form onSubmit={(e) => {
              e.preventDefault();
              handleChangePassword();
            }}>
              <Row className="mt-4 w-100">
                <FormGroup className="w-100">
                  <Label>New Password</Label>
                  <Input
                    placeholder="Enter new password"
                    type="password"
                    name="newPassword"
                    required
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    style={{ color: newPassword ? '#000' : '', opacity: 1 }}

                  />
                </FormGroup>
              </Row>
              <Button
                color="primary"
                type="submit"
                className="mt-4 w-100 mb-10"
                style={{ marginBottom: "1rem" }}
              >
                Update Password
              </Button>
            </Form>
          </ModalBody>



        </Modal>
        <Modal isOpen={showCredentialsModal} toggle={() => setShowCredentialsModal(false)}>
          <ModalHeader>Credentials
            <Button
              className="close"
              onClick={() => setShowCredentialsModal(false)}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column justify-content-center align-items-center" >
            <p>Email: {generatedCredentials.email}</p>
            <p>Password: {generatedCredentials.password}</p>
            <Button
              color="primary"
              onClick={handleCopyToClipboard}
              className="mt-4 w-100 mb-10"
              style={{ marginBottom: "1rem" }}
            >
              Copy Credentials
            </Button>
          </ModalBody>
        </Modal>
        <Footer />
      </Container>
    </>
  );
};

export default TeacherManagement;
